import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface TemplateForkDialogProps {
  open: boolean;
  templateName: string;
  onSave: () => void;
  onEvaluate: () => void;
  onCancel: () => void;
}

export default function TemplateForkDialog({
  open,
  templateName,
  onSave,
  onEvaluate,
  onCancel,
}: TemplateForkDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent className="bg-sl-surface border-sl-surface-2">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-bold text-sl-text">
            Save Template Copy?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sl-muted mt-2 space-y-2">
            <span>
              You're opening <span className="text-sl-text font-semibold">"{templateName}"</span>.
              Would you like to save a copy to your account now, or just evaluate it?
            </span>
            <span className="block text-sm mt-2 text-sl-muted/80">
              If just evaluating, any changes you make and save will result in creating a copied template in your account!
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel
            onClick={onEvaluate}
            className="bg-sl-surface-2 hover:bg-sl-surface border-sl-surface-2 text-sl-text"
          >
            Just Evaluating
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onSave}
            className="bg-sl-accent hover:bg-sl-accent/90 text-white"
          >
            Save as My Template
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
